import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const warmupHubStyles = StyleSheet.create({
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 28,
  },
  bannerWrap: {
    width: '100%',
    paddingHorizontal: 4,
  },
  banner: {
    width: '100%',
  },
  body: {
    paddingHorizontal: 16,
    // Pull the trivia section up toward the (now-static) banner.
    marginTop: -8,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: WARMUP_COLORS.textDim,
    letterSpacing: 1,
    paddingHorizontal: 2,
    paddingTop: 6,
    paddingBottom: 10,
    textTransform: 'uppercase',
  },

  // ---- 2-up grid ----
  // space-between + rowGap (NOT a horizontal `gap`) so two 48% cards never overflow → wrap to a single
  // column on narrow phones (e.g. 320px). The gap between columns is the leftover 4%.
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 14,
  },
});
